














































import { Vue, Component, Watch } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { formats } from 'bits/formats'
import FormatCard from 'vuecomponents/format_card.vue'
import ProcessedImage from 'vuecomponents/processed_image.vue'
import { isTouchScreen } from 'bits/browser'

const browser = namespace('browser')

// Different format for ipad view
// Non touchscreen view (resizing - no scroll)
// 1. Desktop
// 2. Ipad
// 3. Phone
// Touchscreen view (enable scroll)
// 1. Ipad (including Ipad pro) --> (display: grid)
// 2. Phones (mobile view) --> (display: flex)

@Component({
  components: { FormatCard, ProcessedImage },
})
export default class FormatCards extends Vue {
  @browser.State windowWidth
  @browser.State windowHeight
  @browser.Getter isMobileView
  @browser.Getter isSmallerThanTabletLandscape
  touchscreen = isTouchScreen()
  formats = formats
  mobileCardWidth = 268
  mobileCardHeight = 400

  get isMonitorOrTabletView(): boolean {
    return !this.touchscreen || (this.touchscreen && !this.isMobileView)
  }

  get formatCardWidth(): number {
    if (this.isMobileView) {
      return Math.floor(this.windowWidth / 2.4)
    } else if (this.isSmallerThanTabletLandscape) {
      return Math.floor(this.windowWidth / 4.6)
    } else if (this.windowWidth < 1200) {
      return Math.floor(this.windowWidth / 6.3)
    } else if (this.windowWidth < 1500) {
      return Math.floor(this.windowWidth / 5.9)
    }
    return Math.floor(this.windowWidth / 5.5)
  }

  get formatCardHeight(): number {
    let ratio = 5.4 / 10
    if (this.isMobileView) {
      ratio = 0.65
    } else if (this.isSmallerThanTabletLandscape) {
      ratio = 0.63
    } else if (this.windowWidth < 1500) {
      ratio = 0.56
    }

    return Math.floor(this.formatCardWidth * ratio)
  }

  get formatCardTransforms(): object {
    return { width: this.formatCardWidth, height: this.formatCardHeight }
  }

  get formatCardWidthMobileView(): number {
    return this.mobileCardWidth
  }

  get formatCardHeightMobileView(): number {
    return this.mobileCardHeight
  }

  get formatCardTransformsMobileView(): object {
    return { width: this.mobileCardWidth, height: this.mobileCardHeight }
  }

  @Watch('windowWidth')
  onWindowWidthChange(): void {
    this.touchscreen = isTouchScreen()
  }
}
